var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_79028",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n      }\n\n      .st2 {\n        fill: #828282;\n      }\n\n      .st3 {\n        isolation: isolate;\n      }\n\n      .st4 {\n        fill: #fff;\n      }\n\n      .st1 {\n        stroke: #707070;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_146226"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    width: 98,
    height: 102,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 0.5,
    y: 0.5,
    width: 97,
    height: 101,
    rx: 3.5,
    ry: 3.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.7,84.2c0-.3-.1-.6-.3-.7s-.6-.3-1.2-.5-1-.4-1.4-.6c-.6-.4-1-.9-1-1.6s.2-1,.7-1.4,1.1-.6,1.8-.6.9,0,1.3.3.7.4.9.8c.2.3.3.7.3,1.1h-1.2c0-.4-.1-.7-.3-.9-.2-.2-.6-.3-1-.3s-.7,0-.9.3-.3.4-.3.7.1.5.4.7c.2.2.6.3,1.2.5.6.2,1,.4,1.3.6.3.2.6.5.7.7.2.3.2.6.2,1,0,.6-.2,1.1-.7,1.4-.5.4-1.1.5-1.8.5s-1,0-1.4-.3c-.4-.2-.8-.5-1-.8s-.4-.7-.4-1.2h1.2c0,.4.1.7.4.9s.6.3,1.1.3.8,0,1-.3c.2-.2.3-.4.3-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.7,83.3c0-.5.1-1,.3-1.4.2-.4.5-.7.9-1,.4-.2.8-.3,1.3-.3.7,0,1.3.2,1.7.7s.7,1.1.7,1.8v.3c0,.5,0,1-.3,1.4s-.5.7-.9,1-.8.3-1.3.3c-.7,0-1.3-.2-1.8-.7-.4-.5-.7-1.2-.7-2h0ZM42.9,83.4c0,.5.1,1,.3,1.3.2.3.5.5.9.5s.7-.2.9-.5.3-.8.3-1.4-.1-1-.3-1.3-.5-.5-.9-.5-.7.2-.9.5c-.2.3-.3.8-.3,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.8,85.2c.3,0,.5,0,.7-.3s.3-.4.3-.6h1.1c0,.3-.1.6-.3.9-.2.3-.5.5-.8.7s-.7.2-1.1.2c-.7,0-1.3-.2-1.8-.7s-.6-1.1-.6-2h0c0-.9.2-1.6.6-2.1.4-.5,1-.7,1.8-.7s1.1.2,1.5.5c.4.4.6.8.6,1.4h-1.1c0-.3-.1-.6-.3-.7-.2-.2-.4-.3-.7-.3s-.7.1-.9.4c-.2.3-.3.7-.3,1.3v.2c0,.6.1,1,.3,1.3.2.3.5.4.9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.8,79.3c0-.2,0-.3.2-.5.1-.1.3-.2.5-.2s.4,0,.5.2.2.3.2.5,0,.3-.2.4c-.1.1-.3.2-.5.2s-.4,0-.5-.2c-.1-.1-.2-.3-.2-.4ZM54.1,86h-1.2v-5.3h1.2v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.5,86c0-.1,0-.3-.1-.5-.4.4-.8.6-1.4.6s-1-.2-1.3-.5-.5-.7-.5-1.1.2-1,.6-1.3c.4-.3,1-.5,1.8-.5h.7v-.3c0-.3,0-.5-.2-.7-.2-.2-.4-.2-.7-.2s-.5,0-.7.2c-.2.1-.3.3-.3.5h-1.2c0-.3,0-.6.3-.8.2-.3.5-.5.8-.6.3-.1.7-.2,1.1-.2.6,0,1.1.2,1.5.5.4.3.6.7.6,1.3v2.4c0,.5,0,.9.2,1.1h0c0,0-1.2,0-1.2,0ZM57.2,85.1c.2,0,.5,0,.7-.2.2-.1.4-.3.5-.5v-1h-.6c-.4,0-.8,0-1,.2s-.3.4-.3.6,0,.4.2.5c.2.1.4.2.6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62,86h-1.2v-7.5h1.2v7.5Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "font_download_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61963",
    className: "st0",
    d: "M26.5,16.3h45v45H26.5V16.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "facebook"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79029"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62047",
    className: "st2",
    d: "M66,16.3H32c-3,0-5.5,2.5-5.5,5.5v34.1c0,3,2.5,5.5,5.5,5.5h17.5c.7,0,1.3-.6,1.3-1.3h0v-16.1c0-.7-.6-1.3-1.3-1.3h-4.8v-3.8h4.8c.7,0,1.3-.6,1.3-1.3v-5.4c0-2.9,2.4-5.3,5.3-5.3h4.6v3.8h-4.6c-.8,0-1.5.7-1.5,1.5v5.4c0,.7.6,1.3,1.3,1.3h4.8v3.8h-4.8c-.7,0-1.3.6-1.3,1.3v16.1c0,.7.6,1.3,1.3,1.3h10.2c3,0,5.5-2.5,5.5-5.5V21.8c0-3-2.5-5.5-5.5-5.5ZM68.9,55.9c0,1.6-1.3,2.8-2.8,2.8h-8.8v-13.5h4.8c.7,0,1.3-.6,1.3-1.3h0v-6.4c0-.7-.6-1.3-1.3-1.3h-4.8v-2.9h4.8c.7,0,1.3-.6,1.3-1.3h0v-6.4c0-.7-.6-1.3-1.3-1.3h-5.9c-4.4,0-7.9,3.6-7.9,7.9v4.1h-4.8c-.7,0-1.3.6-1.3,1.3v6.4c0,.7.6,1.3,1.3,1.3h4.8v13.5h-16.1c-1.6,0-2.8-1.3-2.8-2.8V21.8c0-1.6,1.3-2.8,2.8-2.8h34.1c1.6,0,2.8,1.3,2.8,2.8v34.1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialComponent);
export default __webpack_public_path__ + "static/media/SocialComponent.c0f2c9f55f688b12cf0cbe6065e83747.svg";
export { ForwardRef as ReactComponent };